import React from "react";

// MUI components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Layout components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
// import Footer from "examples/Footer"; // 若不用可以刪除

function MembershipAnalysisBK() {
  const url = "https://34-8-98-106.sslip.io/app/crm/page-686cbd2a1b3cab0eb3dadbb8?embed=true";

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  會員數據分析
                </MDTypography>
              </MDBox>
              <MDBox pt={3} px={0} width="100%">
                <iframe
                  src={url}
                  width="100%"
                  height="800px"
                  frameBorder="0"
                  title="Metabase Embed"
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default MembershipAnalysisBK;
